<template>
    <div class="input-group date">
        <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
        <input type="text"
               class="form-control"
               :value="value"
               :placeholder="placeholder"
               v-custom-validations="validacion"/>
    </div>
</template>

<script>
import * as moment from 'moment';

export default {
    props: ['value', 'placeholder', 'validacion', 'future', 'init'],
    data() {
        return {
            content: this.value
        }
    },
    watch: {
        value() {
            $(this.$el).datepicker('setDate', this.value);
            this.$emit('input', this.value)
        }
    },
    mounted() {
        const self = this;
        if (self.init)
            self.$emit('input', moment().format('DD/MM/YYYY'))
        const options = {
            setDate: new Date(),
            format: 'dd/mm/yyyy',
            autoclose: true
        }

        if(this.future){
            options['startDate'] = new Date();
        }

        $(self.$el).datepicker(options).on('changeDate', function (ev) {
            if (ev.date) {
                self.$emit('input', moment(ev.date).format('DD/MM/YYYY'))
            }

        }).on('clearDate', function (ev) {

            self.$emit('input', '')
        });

    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/DatePicker.vue